import { GanttRowIntersection } from '../GanttRowIntersection';
import { GanttLoadingSkeleton } from './GanttLoadingSkeleton';
import { GanttQueue } from '../types';

type GanttQueuesSkeletonRendererProps = {
  ganttQueues: GanttQueue[];
  from: Date;
  to: Date;
};

export const GanttQueuesSkeletonRenderer = ({ from, to, ganttQueues }: GanttQueuesSkeletonRendererProps) =>
  ganttQueues.map((queue, index) => (
    <GanttRowIntersection ganttQueues={ganttQueues} key={queue.id} queueId={queue.id}>
      <GanttLoadingSkeleton from={from} rowIndex={index} to={to} />
    </GanttRowIntersection>
  ));
